import { render, staticRenderFns } from "./blob_repository_actions_group.vue?vue&type=template&id=2b5db9b9"
import script from "./blob_repository_actions_group.vue?vue&type=script&lang=js"
export * from "./blob_repository_actions_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports